const n = () => {
  let t;
  return {
    at(u) {
      u && (t = document.activeElement, u == null || u.focus());
    },
    prev() {
      t == null || t.focus(), t = null;
    }
  };
};
export {
  n as default
};
